module.exports = __webpack_public_path__ + "img/creativity-without-exclusivity.9d81e71a.png";